import React, { ReactNode } from 'react';
import { Col, Row } from 'antd';
import { Input } from 'formik-antd';
import * as Yup from 'yup';

import { getFormItemName } from 'utils/fieldArrayUtils';
import FormItem from 'components/formik/FormItem';

import styles from './../BillingInfo.module.less';

export const initialBillingContactValidationSchema = {
  firstName: Yup.string()
    .trim()
    .nullable()
    .max(120, 'First name should be 120 characters maximum'),
  lastName: Yup.string()
    .nullable()
    .trim()
    .max(120, 'Last name should be 120 characters maximum'),
  email: Yup.string()
    .nullable()
    .email('A/P email format is invalid')
    .max(120, 'Email should be 120 characters maximum'),
  phoneNumber: Yup.string()
    .trim()
    .nullable()
    .max(120, 'Phone number should be 120 characters maximum'),
};

export const submitBillingContactValidationSchema = {
  ...initialBillingContactValidationSchema,
  firstName:
    initialBillingContactValidationSchema.firstName.required(
      'Field is required',
    ),
  lastName:
    initialBillingContactValidationSchema.lastName.required(
      'Field is required',
    ),
  email:
    initialBillingContactValidationSchema.email.required('Field is required'),
};

type Props = {
  index: number;
  formNamePrefix?: string;
  actionButtons?: ReactNode;
};

export default React.memo((props: Props) => {
  const { index, actionButtons = null, formNamePrefix } = props;

  const firstNameFormItemName = getFormItemName({
    name: 'firstName',
    index,
    prefix: formNamePrefix,
  });

  const lastNameFormItemName = getFormItemName({
    name: 'lastName',
    index,
    prefix: formNamePrefix,
  });

  const emailFormItemName = getFormItemName({
    name: 'email',
    index,
    prefix: formNamePrefix,
  });

  const phoneNumberFormItemName = getFormItemName({
    name: 'phoneNumber',
    index,
    prefix: formNamePrefix,
  });

  return (
    <Row gutter={40}>
      <Col xs={24} md={12}>
        <Row gutter={20}>
          <Col xs={24} md={12}>
            <FormItem name={firstNameFormItemName} label="A/P first name *">
              <Input
                name={firstNameFormItemName}
                placeholder="Enter A/P first name"
                autoComplete="off"
              />
            </FormItem>
          </Col>
          <Col xs={24} md={12}>
            <FormItem name={lastNameFormItemName} label="A/P last name *">
              <Input
                name={lastNameFormItemName}
                placeholder="Enter A/P last name"
                autoComplete="off"
              />
            </FormItem>
          </Col>
        </Row>
      </Col>
      <Col xs={24} md={12}>
        <Row gutter={20}>
          <Col xs={24} md={12}>
            <FormItem name={emailFormItemName} label="A/P email *">
              <Input name={emailFormItemName} placeholder="Enter A/P email"
                     autoComplete="off"
              />
            </FormItem>
          </Col>
          <Col xs={24} md={12}>
            <FormItem label="A/P phone number" name={phoneNumberFormItemName}>
              <Input
                name={phoneNumberFormItemName}
                placeholder="Enter phone number"
                autoComplete="off"
              />
            </FormItem>
          </Col>
        </Row>
      </Col>
      {actionButtons && (
        <Col xs={24}>
          <div className={styles.actionButtons}>{actionButtons}</div>
        </Col>
      )}
    </Row>
  );
});
